import styled from 'styled-components';

import { Button, ButtonVariant, ButtonSize, iconFill } from '@catalyze/ui';

export const Container = styled(Button).attrs({
    variant: ButtonVariant.SECONDARY,
    size: ButtonSize.SMALL,
})`
    font-weight: 400;
    display: inline-flex;
    border-radius: 0;
    border-left-width: 0;
    min-height: 2.5rem;
    line-height: 1;

    &,
    &:active,
    &:hover,
    &:focus {
        border-color: ${({ theme }) => theme.colors.mediumShadow};
    }

    &:first-of-type {
        border-left-width: 1px;
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
    }

    &:last-of-type {
        border-top-right-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
    }

    & > svg {
        margin-left: 0.25rem;
        width: 0.5rem;
        ${({ theme }) => iconFill(theme.colors.fontTertiary)}
    }
`;
